// Modal title with a Font Awesome icon that matches the modal's purpose.
// Used with className "tech-modal" on the <Modal> (styles in
// TechnicianDesignSystem.css): Jaipuria maroon header, the real icon here,
// and the generic icon tile from public/assets/style.css switched off.
import React from "react";
import { Modal } from "react-bootstrap";

const TechModalTitle = ({ icon, children, className = "", id }) => (
  <Modal.Title id={id} className={`tech-modal-title ${className}`.trim()}>
    <span className="tech-modal-icon" aria-hidden="true">
      <i className={`fa-solid ${icon}`}></i>
    </span>
    <span className="tech-modal-text">{children}</span>
  </Modal.Title>
);

export default TechModalTitle;
